import React, { useState } from 'react'
import { supabase } from '../lib/supabase'

export default function Login({ setSession }) {
  const [email,    setEmail]    = useState('')
  const [password, setPassword] = useState('')
  const [error,    setError]    = useState('')
  const [loading,  setLoading]  = useState(false)

  async function handleLogin(e) {
    e.preventDefault()
    setError('')
    setLoading(true)
    const { data, error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) { setError(error.message); setLoading(false); return }
    setSession(data.session)
  }

  return (
    <>
      <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700;800;900&family=Dancing+Script:wght@700&family=Inter:wght@300;400;500;600&display=swap" />
      <style>{`
        .login-root { position:fixed; inset:0; display:flex; align-items:stretch; font-family:'Inter',sans-serif; }
        .login-bg { position:fixed; inset:0; z-index:0;
          background-image:url('/bg.jpg');
          background-size:cover; background-position:center 28%;
          filter:brightness(0.15) saturate(0.28); }
        .login-ov { position:fixed; inset:0; z-index:1;
          background:
            linear-gradient(108deg,rgba(4,10,28,.88) 0%,rgba(4,10,28,.62) 52%,rgba(4,10,28,.28) 100%),
            radial-gradient(ellipse at 18% 55%,rgba(13,43,94,.55) 0%,transparent 60%); }
        .login-left { position:relative; z-index:10; flex:1; display:flex; flex-direction:column;
          padding:40px 52px; justify-content:space-between; }
        .ktirs-logo { display:flex; align-items:center; gap:13px; }
        .ktirs-logo img { width:68px; height:68px; border-radius:50%;
          border:2px solid rgba(232,99,26,.52);
          box-shadow:0 0 0 4px rgba(232,99,26,.10); }
        .ktirs-wordmark { display:flex; flex-direction:column; gap:3px; }
        .ktirs-name { font-family:'Montserrat',sans-serif; font-weight:800; font-size:11px;
          letter-spacing:.16em; text-transform:uppercase; color:rgba(255,255,255,.82); }
        .ktirs-sub { font-size:9.5px; font-weight:500; letter-spacing:.12em; text-transform:uppercase;
          color:rgba(232,99,26,.78); }
        .login-hero { display:flex; flex-direction:column; line-height:1.0; }
        .hero-katsina { font-family:'Montserrat',sans-serif; font-weight:900;
          font-size:clamp(38px,5vw,64px); color:#ffffff; letter-spacing:-.01em; text-transform:uppercase; }
        .hero-informal { font-family:'Dancing Script',cursive; font-weight:700;
          font-size:clamp(34px,4.4vw,58px); color:#E8631A; letter-spacing:.01em; margin-top:-4px; }
        .hero-collections { font-family:'Montserrat',sans-serif; font-weight:900;
          font-size:clamp(38px,5vw,64px); color:#ffffff; letter-spacing:-.01em;
          text-transform:uppercase; margin-top:-2px; }
        .hero-project { font-family:'Montserrat',sans-serif; font-weight:900;
          font-size:clamp(38px,5vw,64px); color:#ffffff; letter-spacing:-.01em;
          text-transform:uppercase; opacity:.18; margin-top:-6px; }
        .hero-desc { margin-top:20px; font-size:12.5px; font-weight:400;
          color:rgba(255,255,255,.35); letter-spacing:.04em; max-width:380px; line-height:1.7; }
        .hero-targets-btn {
          display:inline-flex; align-items:center; gap:8px;
          margin-top:20px; padding:12px 24px;
          background:linear-gradient(135deg,#E8631A 0%,#c34c0c 100%);
          border:none; border-radius:10px; cursor:pointer;
          font-family:'Montserrat',sans-serif; font-weight:800;
          font-size:11px; letter-spacing:.14em; text-transform:uppercase;
          color:#fff; text-decoration:none;
          box-shadow:0 5px 22px rgba(232,99,26,.35);
          transition:opacity .2s,transform .15s; width:fit-content;
        }
        .hero-targets-btn:hover { opacity:.88; transform:translateY(-1px); }
        .bank-corner { display:flex; align-items:center; gap:10px; }
        .bank-lbl { font-size:9px; font-weight:500; letter-spacing:.14em; text-transform:uppercase;
          color:rgba(255,255,255,.28); }
        .bank-corner img { height:18px; filter:brightness(0) invert(1); opacity:.32; }
        .login-right { position:relative; z-index:10; display:flex; align-items:center;
          justify-content:center; padding:40px 52px 40px 24px; }
        .login-card { width:400px; max-width:calc(100vw - 32px);
          background:rgba(255,255,255,.054); border:1px solid rgba(255,255,255,.10);
          border-radius:22px; backdrop-filter:blur(32px) saturate(1.5);
          -webkit-backdrop-filter:blur(32px) saturate(1.5); padding:36px 40px 30px;
          box-shadow:0 0 0 1px rgba(255,255,255,.03) inset,
            0 44px 100px rgba(0,0,0,.72),0 0 80px rgba(13,43,94,.22);
          display:flex; flex-direction:column; align-items:center; }
        .card-logo { width:100%; display:flex; justify-content:center; margin-bottom:16px; }
        .card-logo img { width:80%; max-width:280px; height:auto; display:block; }
        .app-name { font-family:'Montserrat',sans-serif; font-weight:900; font-size:13px;
          letter-spacing:.14em; text-transform:uppercase; color:rgba(255,255,255,.88);
          text-align:center; margin-bottom:3px; }
        .app-sub { font-size:10.5px; font-weight:400; color:rgba(255,255,255,.35);
          text-align:center; margin-bottom:18px; letter-spacing:.02em; }
        .login-div { width:100%; height:1px; margin-bottom:18px;
          background:linear-gradient(90deg,transparent,rgba(255,255,255,.13) 35%,rgba(255,255,255,.13) 65%,transparent); }
        .login-form { width:100%; display:flex; flex-direction:column; gap:13px; }
        .login-lbl { display:block; font-size:10px; font-weight:600; letter-spacing:.14em;
          text-transform:uppercase; color:rgba(255,255,255,.36); margin-bottom:5px; }
        .login-inp { width:100%; padding:12px 14px; background:rgba(255,255,255,.07);
          border:1px solid rgba(255,255,255,.11); border-radius:10px; color:#fff;
          font-size:14px; font-family:'Inter',sans-serif; outline:none;
          transition:border-color .2s,background .2s; box-sizing:border-box; }
        .login-inp::placeholder { color:rgba(255,255,255,.18); }
        .login-inp:focus { border-color:rgba(232,99,26,.5); background:rgba(255,255,255,.10); }
        .login-btn { width:100%; padding:13.5px; margin-top:4px;
          background:linear-gradient(135deg,#E8631A 0%,#c34c0c 100%);
          border:none; border-radius:10px; color:#fff;
          font-family:'Montserrat',sans-serif; font-weight:800;
          font-size:12px; letter-spacing:.16em; text-transform:uppercase;
          cursor:pointer; transition:opacity .2s,transform .15s;
          box-shadow:0 5px 22px rgba(232,99,26,.4); }
        .login-btn:hover { opacity:.88; transform:translateY(-1px); }
        .login-btn:active { transform:translateY(0); }
        .login-btn:disabled { opacity:.55; cursor:not-allowed; transform:none; }
        .login-error { width:100%; padding:10px 14px; border-radius:8px; font-size:12px;
          color:#ff7b6b; background:rgba(255,80,60,.10); border:1px solid rgba(255,80,60,.22);
          margin-bottom:4px; }
        .evc-row { display:flex; align-items:center; justify-content:center; gap:9px;
          margin-top:20px; padding-top:16px; width:100%;
          border-top:1px solid rgba(255,255,255,.07); }
        .evc-lbl { font-size:8.5px; font-weight:500; letter-spacing:.13em; text-transform:uppercase;
          color:rgba(255,255,255,.26); }
        .evc-row img { height:32px; display:block; filter:brightness(0) invert(1); opacity:.55; }
        @media(max-width:820px){
          .login-root { flex-direction:column; overflow-y:auto; overflow-x:hidden; }
          .login-left { padding:24px; flex:none; }
          .login-right { padding:16px 16px 36px; }
          .hero-katsina,.hero-collections,.hero-project { font-size:32px; }
          .hero-informal { font-size:29px; }
        }
        @media(max-height:700px){
          .login-card { padding:22px 34px 20px; }
          .card-logo img { width:65%; }
          .app-sub { margin-bottom:12px; }
        }
      `}</style>

      <div className="login-root">
        {/* Background photo + overlay */}
        <div className="login-bg" />
        <div className="login-ov" />

        {/* LEFT — branding */}
        <div className="login-left">
          {/* Top: KTIRS logo + wordmark */}
          <div className="ktirs-logo">
            <img src="/ktirs-logo.png" alt="KT-IRS" />
            <div className="ktirs-wordmark">
              <span className="ktirs-name">Katsina Internal Revenue Service</span>
              <span className="ktirs-sub">KT-IRS &nbsp;·&nbsp; Katsina State</span>
            </div>
          </div>

          {/* Centre: hero text */}
          <div className="login-hero">
            <div className="hero-katsina">Katsina State</div>
            <div className="hero-informal">Informal Sector</div>
            <div className="hero-collections">Collections</div>
            <div className="hero-project">Project</div>
            <p className="hero-desc">
              Agent Monitoring Framework &amp; Compliance Scoring — Maximising the revenue
              collection potential and field monitoring of our agent partners.
            </p>
            <a href="/targets" className="hero-targets-btn">
              View SA Weekly Targets →
            </a>
          </div>

          {/* Bottom: Access Bank */}
          <div className="bank-corner">
            <span className="bank-lbl">Banking Partner</span>
            <img src="/access-logo.png" alt="Access Bank" />
          </div>
        </div>

        {/* RIGHT — login card */}
        <div className="login-right">
          <div className="login-card">
            {/* ACSM logo */}
            <div className="card-logo">
              <img src="/acsm-logo.png" alt="ACSM" />
            </div>

            <p className="app-name">Agent Compliance Scoring &amp; Monitoring</p>
            <p className="app-sub">Agent Monitoring Framework &amp; Compliance Scoring</p>

            <div className="login-div" />

            <form className="login-form" onSubmit={handleLogin}>
              {error && <div className="login-error">{error}</div>}

              <div>
                <label className="login-lbl">Email Address</label>
                <input
                  className="login-inp"
                  type="email"
                  placeholder="agent@ktirs.gov.ng"
                  autoComplete="email"
                  value={email}
                  required
                  onChange={e => setEmail(e.target.value)}
                />
              </div>

              <div>
                <label className="login-lbl">Password</label>
                <input
                  className="login-inp"
                  type="password"
                  placeholder="••••••••"
                  autoComplete="current-password"
                  value={password}
                  required
                  onChange={e => setPassword(e.target.value)}
                />
              </div>

              <button className="login-btn" type="submit" disabled={loading}>
                {loading ? 'Signing in…' : 'Sign In'}
              </button>
            </form>

            {/* EVC branding */}
            <div className="evc-row">
              <span className="evc-lbl">Powered by</span>
              <img src="/evc-logo.png" alt="Evolucionar Consultants" />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
